<div class="tw-w-full tw-h-full tw-bg-white tw-rounded-t-3xl tw-relative tw-overflow-hidden">
  <!-- Close button -->
  <div class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-3 tw-right-3"
       style="width: 35px; height: 35px">
    <div class="tw-text-gray-500 tw-text-500 tw-font-bold tw-cursor-pointer"
         (click)="closeSheet()">&#10005;</div>
  </div>

  <!-- Compact header (hidden initially, slides in when expanded header scrolls out) -->
  <div class="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-z-50
              tw-bg-gray-100 tw-border-b tw-border-gray-100
              tw-px-4 tw-pt-3 tw-pb-2 tw-pr-14
              tw-flex tw-items-center tw-gap-3
              tw-rounded-t-3xl
              tw-transition-all tw-duration-300 tw-ease-in-out"
       [class.tw-opacity-0]="!isCompactHeaderVisible()"
       [class.tw-opacity-100]="isCompactHeaderVisible()"
       [class.tw--translate-y-full]="!isCompactHeaderVisible()"
       [class.tw-translate-y-0]="isCompactHeaderVisible()"
       [class.tw-pointer-events-none]="!isCompactHeaderVisible()"
       [class.tw-pointer-events-auto]="isCompactHeaderVisible()">
    @if (data.doctor.get('doctorDisplayImage') || data.doctor.get('DoctorImageThumbnail')) {
      <img class="tw-flex-none tw-h-10 tw-w-10 tw-rounded-full tw-bg-green-100 tw-object-contain"
           [src]="data.doctor.get('doctorDisplayImage') || data.doctor.get('DoctorImageThumbnail')"
           alt="Doctor" />
    }
    <div class="tw-flex-1 tw-min-w-0">
      <p class="tw-font-lexend tw-font-bold tw-text-300 tw-leading-tight tw-text-[#222] tw-truncate tw-mb-1">
        {{ data.doctor.get('DoctorDisplayName') }}
      </p>
      <p class="tw-font-body tw-text-100 tw-text-gray-400 tw-truncate">
        {{ conn.getQualifyText(data.doctor) }}
      </p>
    </div>
  </div>

  <!-- Single scroll container -->
  <div #scrollContainer class="tw-overflow-y-auto tw-h-full">
    <!-- Expanded header (normal flow — scrolls with content) -->
    <section #expandedHeader class="tw-bg-gray-100 tw-px-4 tw-pt-5">
      <div class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-gap-3">
        <div class="tw-flex-1">
          <h1 class="tw-font-lexend tw-font-bold tw-text-[22px] tw-leading-[23.4px] tw-text-[#222]">
            {{ data.doctor.get('DoctorDisplayName') }}
          </h1>
          <p class="tw-font-body tw-text-200 tw-text-gray-400 tw-mt-1">
            {{ conn.getQualifyText(data.doctor) }}
          </p>
          <!-- Divider -->
          <div class="tw-w-[151px] tw-h-px tw-bg-black tw-opacity-10 tw-my-2"></div>
          <!-- MCI info -->
          @if (data.doctor.get('mciNumber') && !data.doctor.get('forDoctor')) {
            <p class="tw-font-body tw-font-bold tw-text-[10px] tw-text-[#222]">
              Medical Council<br />
              Reg Number - {{ data.doctor.get('mciNumber') }}
            </p>
          }
        </div>
        @if (data.doctor.get('doctorDisplayImage') || data.doctor.get('DoctorImageThumbnail')) {
          <img class="tw-flex-none tw-w-36"
               [src]="data.doctor.get('DoctorImageThumbnail')"
               alt="Doctor" />
        }
      </div>
    </section>

    <!-- Content -->
    <div [class.tw-pb-20]="showCTA()" [class.tw-pb-4]="!showCTA()">
      <!-- Tags -->
      @if (data.doctor.get('tags')?.length) {
        <ul class="tw-flex tw-flex-row tw-items-center tw-flex-wrap tw-gap-2 tw-px-4 tw-pt-4 tw-pb-2">
          @for (tag of data.doctor.get('tags'); track tag) {
            <li class="tw-flex-none tw-flex tw-items-center tw-bg-teal-100 tw-rounded-2 tw-py-1.5 tw-px-2">
              <span class="tw-font-lexend tw-text-100 tw-font-normal tw-text-[#4EAE9C]">{{ tag }}</span>
            </li>
          }
        </ul>
      }

      <!-- Know your doctor -->
      @if (data.doctor.get('doctorProfessionalArea')) {
        <section class="tw-px-4 tw-pt-4 tw-pb-2">
          <h2 class="tw-font-lexend tw-font-bold tw-text-400 tw-text-gray-900 tw-mb-2" i18n="@@aboutYourDoctor">
            Know your doctor
          </h2>
          <p class="tw-font-body tw-text-200 tw-text-gray-500">
            {{ data.doctor.get('doctorProfessionalArea') }}
          </p>
        </section>
      }

      <!-- Qualifications -->
      @if (data.doctor.get('doctorQualificationDetail')) {
        <section class="tw-px-4 tw-pt-2 tw-pb-4">
          <h2 class="tw-font-lexend tw-font-bold tw-text-400 tw-text-gray-900 tw-mb-2" i18n="@@qualification">
            Qualifications
          </h2>
          <p class="tw-font-body tw-text-200 tw-text-gray-500">
            {{ data.doctor.get('doctorQualificationDetail') }}
          </p>
        </section>
      }
    </div>
  </div>

  <!-- Buy Treatment Kit CTA (regimen only) -->
  @if (showCTA()) {
    <div class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-px-4 tw-py-3 tw-bg-white tw-border-t tw-border-gray-100 tw-z-40">
      <button class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3.5 tw-rounded-xl tw-font-lexend tw-font-bold tw-text-[16px] tw-leading-[20.8px] tw-text-center"
              i18n="@@buyTreatmentKit"
              (click)="onBuyNow()">
        Buy Treatment Kit
      </button>
    </div>
  }
</div>
